// extracted by mini-css-extract-plugin
module.exports = {"contents":"ua_contents__p8R93","inv":"ua_inv___WYwV","invflttop":"ua_invflttop__3S2cI"};